import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Chip,
  List,
  ListItem,
  ListItemSuffix,
  Typography,
} from '@material-tailwind/react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ListItemArvore = ({ array, title, open, handleOpen, index }) => {
  const [table, setTable] = useState(false);

  const handlTable = () => {
    setTable(!table);
  };

  return (
    <>
      <Accordion open={open === index} className="border-b border-white">
        <AccordionHeader
          className="dark:bg-darkButtonColor bg-lightButtonColor text-darkText px-2 py-2  cursor-pointer border-none uppercase hover:text-darkText dark:hover:text-opacity-65 "
          onClick={() => handleOpen(index)}
        >
          <Typography variant="h6">{title}</Typography>
          <ListItemSuffix
            className={`-rotate-90 ${open === index && 'rotate-[90] transition-all'}`}
          >
            ▼
          </ListItemSuffix>
        </AccordionHeader>
        <AccordionBody>
          <List className="text-white max-h-96 overflow-auto">
            {array &&
              array.map((item) => (
                <Link key={item.tag} to={`/arvore-peças/${item.tag}/${item.nome}`}>
                  <ListItem
                    className="dark:bg-darkListItemBox dark:hover:text-cyan-400 dark:focus:text-yellow-600 uppercase bg-darkRbgEstq  "
                    ripple={false}
                  >
                    <div>
                      <Typography
                        variant="small"
                        className="font-normal text-gray-300 dark:text-gray-400 uppercase text-xs "
                      >
                        {item.tag}
                      </Typography>
                      <Typography
                        variant="small"
                        className="font-semibold text-white  dark:text-darkText"
                      >
                        {item.nome}
                      </Typography>
                    </div>
                  </ListItem>
                </Link>
              ))}
          </List>
        </AccordionBody>
      </Accordion>
    </>
  );
};

export default ListItemArvore;
